<template>
  <div
    class="mb-32 flex flex-col justify-between gap-x-[73px] py-16 md:flex-row"
  >
    <div class="mb-32 flex flex-col items-start text-left md:mb-0">
      <p class="heading-2">{{ i18n(translations.titleLabel) }}</p>
      <p class="body-2">{{ i18n(translations.textLabel) }}</p>
    </div>

    <div class="flex flex-col md:w-[60%]">
      <EmailCollectorForm
        buttonClasses="!w-fit !min-w-fit"
        :placeholder-label="i18n(translations.inputLabel)"
        source="footer"
        :submitButtonLabel="i18n(translations.submitButtonLabel)"
        :tracking="trackingData"
      />

      <RevLink
        class="flex items-center pt-16"
        @click="legalTermsOpen = !legalTermsOpen"
      >
        <component
          :is="legalTermsOpen ? IconChevronUp : IconChevronDown"
          class="size-24"
        />

        <p class="caption-bold">{{ i18n(translations.legalTermsLabel) }}</p>
      </RevLink>

      <div
        v-show="legalTermsOpen"
        class="text-static-default-mid caption ml-24 mt-4"
      >
        <p v-if="i18n(translations.legalTextShort).length">
          {{ i18n(translations.legalTextShort) }}
        </p>

        <RevLink
          v-if="i18n(translations.legalTermsDetails).length"
          class="mt-4 block"
          target="_blank"
          :to="`${currentLocale}/legal/data-protection`"
        >
          <span> {{ i18n(translations.legalTermsDetails) }} </span>
        </RevLink>

        <p v-if="i18n(translations.legalTermsText).length" class="mt-12">
          {{ i18n(translations.legalTermsText) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import EmailCollectorForm from '@backmarket/nuxt-layer-cms/EmailCollectorForm.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { RevLink } from '@ds/components/Link'
import { IconChevronDown } from '@ds/icons/IconChevronDown'
import { IconChevronUp } from '@ds/icons/IconChevronUp'

import translations from './FooterEmailCollector.translations'

const i18n = useI18n()
const currentLocale = useI18nLocale()

const legalTermsOpen = ref(false)

const trackingData = {
  name: i18n(translations.titleLabel),
  value: 'FooterEmailCollector',
}
</script>
